<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" height="1em" width="1em" fill="currentColor">
<path d="M7.3,4.1c0,0,.2.2.4.2h3c.4,0,.6.5.2.7l-2.4,1.8c0,0-.2.2,0,.5l.9,2.8c0,.4-.4.7-.6.5l-2.5-1.8c0,0-.4,0-.5,0l-2.5,1.8c-.2.2-.7,0-.6-.5l.9-2.8c0,0,0-.4,0-.5l-2.4-1.8c-.4-.2-.2-.7.2-.7h3c0,0,.4,0,.4-.2l.9-2.8c0-.5.6-.5.7,0l.8,2.8Z"/>
</svg>
